import { NavLink } from "react-router-dom";

import { Card } from "react-bootstrap";
import { addCommas } from "@persian-tools/persian-tools";
import { pathMaker } from "../../utils/helperFunction";

import { FaEye } from "react-icons/fa";

import { DeleteIcon, TickIcon } from "../kits/Icons";
import ColorSchema from "../kits/Color";
import { swalFunc } from "../../utils/helperFunction";
import useAxios from "../../services/useAxios";

import placeholder from "../../assets/images/vertical-placeholder-image.jpg";
export default function ProductItem({ array, deactivateProduct }) {
  return (
    <Card
      className={`d-flex  flex-wrap my-3 product-item `}
      style={{
        backgroundColor: array.status == -1 && ColorSchema.dark_light_custom,
        borderColor: array.status == -1 && ColorSchema.dark_light_custom,
      }}
    >
      <div className="image">
        <img
          className=" m-auto w-100 h-100 p-1"
          src={array["image"] != "" ? pathMaker(array["image"]) : placeholder}
        />
      </div>
      <div className="d-flex flex-wrap second-part">
        <div className={`flex-grow-1 p-2 title`}>
          <h6 className="title-header">عنوان</h6>

          <p className="text-center pt-2 mt-3 value">{array.title}</p>
        </div>

        <div className={`flex-grow-1 p-2 type`}>
          <h6 className="title-header">نوع</h6>

          <p className="text-center pt-2 mt-3 value">
            {array?.type?.label != "" ? array?.type?.label : "---"}
          </p>
        </div>

        <div className={`flex-grow-1 p-2 price`}>
          <h6 className="title-header">
            {array?.type?.value == 1
              ? `سود(${array?.priceType})`
              : `قیمت پایه(تومان)`}
          </h6>

          <p className="text-center pt-2 mt-3 value">
            {addCommas(array?.price)}
          </p>
        </div>

        <div className={`flex-grow-1 p-2 discount`}>
          <h6 className="title-header">تخفیف</h6>

          <p className="text-center pt-2 mt-3 value">
            {addCommas(array?.discount)}
          </p>
        </div>

        <div className="w-100 px-2 py-3 d-flex description">
          <h6 className="pe-4">توضیحات</h6>
          <p className="ps-2">
            {array?.description != "" ? array?.description : "----"}
          </p>
          <p className="text-center ps-2 ms-auto value d-flex justify-content-center align-items-end">
            <NavLink to={`/new-single-product/${array.id}`}>
              <FaEye
                style={{ width: 18, height: 18 }}
                className="me-1 cursor-pointer"
                color={ColorSchema.blue_custom}
              />
            </NavLink>
            {array.status == 0 ? (
              <button
                onClick={() => {
                  deactivateProduct(array.id, -1);
                }}
              >
                <DeleteIcon
                  containerIconClassName="cursor-pointer"
                  style={{ width: 18, height: 18 }}
                  color={ColorSchema.red_custom}
                />
              </button>
            ) : (
              <button
                onClick={() => {
                  deactivateProduct(array.id, 0);
                }}
              >
                <TickIcon
                  containerIconClassName="cursor-pointer"
                  style={{ width: 18, height: 18 }}
                  color={ColorSchema.success_custom}
                />
              </button>
            )}
          </p>
        </div>
      </div>
    </Card>
  );
}
